module.exports = __webpack_public_path__ + "img/SKMJ_fire1.6e64daea.jpg";